window.bmLib = {
    existingTriggers: {},

    closePopupWizard: function () {
        $('#popup-wizard').modal('hide');
        $('body').removeClass('wizard-opened');
        $('body').removeAttr('wizard-opened');
        $('.body').removeAttr('data-wizard-name');
        wizardSideBar.hide();
    },

    fireTrigger: function (triggerName, elementName, data) {
        let _data = data || [];

        if (!Array.isArray(_data)) {
            _data = [_data];
        }

        $(elementName).trigger(triggerName, _data);
        let argsArray = _data.slice();
        // add a first null arg because when invoking the function through $(elementName).on(triggerName, func); it adds a first arg with obj of the event
        argsArray.unshift(null);
        this.existingTriggers[triggerName] = argsArray;
    },

    addTriggerListener: function (triggerName, elementName, func) {
        if (this.existingTriggers[triggerName]) {
            func.apply(null, this.existingTriggers[triggerName]);
        }
        $(elementName).on(triggerName, func);
    },

    updateSelectElement: function (selectElement, index, value) {
        selectElement.selectedIndex = index;
        selectElement.value = value;
        triggerEventOnElement(selectElement, 'change');
    }, 

    addThirdPartyScript: function (name, src, category, additionalConf) {

        if (!category || category == _NECESSARY) {
            bmLib.addScript(name, src, additionalConf);
        } 
        else if (getCookieCategory(category) && !$('script[id="' + name + '"]').length) {
            bmLib.addScript(name, src, additionalConf);
        } 
        else {
            bmLib.addTriggerListener('cookiePolicyAnswers', 'body', function () {
                if (getCookieCategory(category) && !$('script[id="' + name + '"]').length) {
                    bmLib.addScript(name, src, additionalConf);
                }
            });
        }
    }, 

    addScript: function (name, src, additionalConf) {
        // check if src is a link or inline code
        let inline = !(src.substring(0, 4) == 'http');
        let elementId = (typeof additionalConf !== 'undefined' && additionalConf.elementId) ? additionalConf.elementId : name;

        let scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.id = elementId;

        if (inline) {
            scriptElement.text = src;
        } else {
            scriptElement.src = src;
        }
        $('head').append(scriptElement);
        bmLib.fireTrigger(name + 'Inserted', 'body');
    }
};